import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE } from "../lib/whatsapp";

const services = [
  {
    title: "Mariages",
    text: "Une brigade en tenue d'apparat pour sublimer le plus beau jour de votre vie, du cocktail à la pièce montée.",
    img: "/images/hero.png",
    testid: "service-mariages",
  },
  {
    title: "Vins d'honneur",
    text: "Plateaux de champagne, petits fours, service à l'assiette : l'élégance de la réception à la française.",
    img: "/images/pour.png",
    testid: "service-vins",
  },
  {
    title: "Conférences & galas",
    text: "Dîners de gala, lancements, cérémonies : un service synchronisé sous la direction de votre maître d'hôtel.",
    img: "/images/conference.png",
    testid: "service-conferences",
  },
  {
    title: "Réceptions privées",
    text: "Anniversaires, baptêmes, dîners d'affaires : le service d'un grand hôtel, chez vous.",
    img: "/images/maitre.png",
    testid: "service-receptions",
  },
  {
    title: "Hôtes & hôtesses d'accueil",
    text: "Un accueil souriant et élégant : orientation de vos invités, vestiaire, distribution de programmes et accompagnement VIP.",
    img: "/images/hotesse.png",
    testid: "service-hotesse",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="grain relative bg-[#f9f8f6] px-6 py-28 text-[#0a0a0a] lg:px-10 lg:py-40">
    <div className="mx-auto max-w-7xl">
      <div className="mb-24 flex flex-wrap items-end justify-between gap-8">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="mb-6 text-[11px] font-semibold uppercase tracking-[0.4em] text-[#aa8c2c]"
          >
            Nos prestations
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="font-display text-4xl leading-tight tracking-tight text-[#0a0a0a] sm:text-5xl lg:text-6xl"
          >
            Pour chaque événement, <br />
            <em className="italic text-[#aa8c2c]">une équipe dédiée.</em>
          </motion.h2>
        </div>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          className="max-w-xs text-sm leading-relaxed text-[#0a0a0a]/50"
        >
          Serveurs, serveuses et maître d'hôtel mis à disposition à l'heure ou à la journée,
          partout où votre événement se déroule.
        </motion.p>
      </div>
      <div className="grid gap-6 sm:grid-cols-2 lg:gap-8">
        {services.map((s, i) => (
          <motion.a
            key={s.testid}
            href={waLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={s.testid}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: (i % 2) * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className={`group relative block overflow-hidden rounded-3xl border border-[#0a0a0a]/10 bg-white shadow-lg ${
              i % 2 === 1 ? "lg:translate-y-16" : ""
            }`}
          >
            <div className="relative aspect-[4/3] overflow-hidden">
              <img
                src={s.img}
                alt={s.title}
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent" />
            </div>
            <div className="flex items-start justify-between gap-6 p-8 lg:p-10">
              <div>
                <h3 className="font-display text-3xl tracking-tight text-[#0a0a0a]">{s.title}</h3>
                <p className="mt-3 max-w-sm text-sm leading-relaxed text-[#0a0a0a]/55">{s.text}</p>
              </div>
              <span className="mt-1 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#0a0a0a]/15 text-[#0a0a0a]/60 transition-colors duration-300 group-hover:border-[#aa8c2c] group-hover:bg-[#aa8c2c] group-hover:text-white">
                <ArrowUpRight className="h-5 w-5" />
              </span>
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  </section>
);
